import menuApi from '@/resources/system/menu'
import {getTree} from '@/common/utils'
import menusData from '@/mocks/data/menu'


export default {
    namespaced: true,
    state: {
        isLoadMenus: false,
        menuList: '',
        btnPerms: {},
    },
    getters: {
        menuList: s => s.menuList,
        btnPerms: s => s.btnPerms,
    },
    actions: {
        getMenuList(c, params) {
            //请求先注释，后台暂未提供接口，先写假数据

            // let res = {
            //   returnCode: 200,
            //   returnMsg: "请求成功",
            //   data: menusData,
            // };
            //
            // let list1 = JSON.parse(JSON.stringify(res.data))
            // let list2 = JSON.parse(JSON.stringify(res.data))
            //
            // let menuData = getTree(list1, node => node.type === 1);
            // let butData = getTree(list2, node => node.type === 2);
            //
            // c.commit('setMenuList', menuData);
            // c.commit('setButDatat', butData);
            // return Promise.resolve(res)
            //

            return menuApi.getMenuList(params).then(res => {
                if (res.returnCode === 200) {
                    let list1 = JSON.parse(JSON.stringify(res.data))
                    let list2 = JSON.parse(JSON.stringify(res.data))

                    let menuData = getTree(list1, node => node.type === 1);
                    let butData = getTree(list2, node => node.type === 2);

                    c.commit('setMenuList', menuData);
                    c.commit('setButDatat', butData);
                    return Promise.resolve(menuData)
                }
            })

        },
    },


    mutations: {
        //把导航菜单 数据存state和sessionStorage
        setMenuList(state, data) {
            state.menuList = data;
            state.isLoadMenus = true;
            sessionStorage.menuList = JSON.stringify(data);
        },
        setButDatat(state, data) {
            for (let item of data) {
                let field = item.parentId + '';
                let val = item.identification;
                if (state.btnPerms[field]) {
                    state.btnPerms[field].push(val)
                } else {
                    state.btnPerms[field] = [val]
                }
            }
            sessionStorage.btnPerms = JSON.stringify(state.btnPerms);
        },
        //加载导航数据，判断sessionStorage有无数据
        loadMenus(state, data) {
            let ms = sessionStorage.menuList;
            if (ms && ms !== 'undefind' && ms.length > 0) {
                state.menuList = JSON.parse(ms);
                state.isLoadMenus = true;
            } else {
                state.menuList = [];
                state.isLoadMenus = false;
            }
        },


    }
}
